import { DEFAULT_SEARCH_MATCH_MODE } from "@/constants";
import type {
  DeadlineOutput,
  PaginatedProjectListOutput,
  ProjectItem,
  ProjectListParams,
  ProjectStatusOutput,
  RecentProjectItem,
  SearchMatchMode,
} from "@/types";
export const standardAcronymsMock = ["GISTM", "ANCOLD", "MAC", "ICOLD", "CRIRSCO"];

export const projectMock = {
  project_id: "41bffaa4-0f7e-49f0-b2fa-81bf49318f9d",
  project_code: "GIST-VAL-FAB-001",
};

export const projectListMock = [
  {
    project_id: "41bffaa4-0f7e-49f0-b2fa-34hoh9394893",
    project_code: "GIST-VAL-FAB-001",
  },
  {
    project_id: "41bffaa4-0f7e-49f0-b2fa-2o3h4oh2ohou",
    project_code: "GIST-VAL-FAB-002",
  },
  {
    project_id: "7c3e1a2b-5f84-4d91-a3c7-91bc3e2f5d08",
    project_code: "GIST-BHP-MNG-001",
  },
  {
    project_id: "b2d94f61-1e07-4b38-8c5a-d47f2e9c1a33",
    project_code: "GIST-ANT-CER-003",
  },
  {
    project_id: "e5a7c830-9d42-4f17-b6e2-208c4b7d3f91",
    project_code: "GIST-SAM-ITB-002",
  },
];

export const recentProjectMock: RecentProjectItem[] = [
  {
    project_code: "GIST-VAL-FAB-001",
    standard_acronym: "GISTM",
    site_name: "Fábrica",
    assets: ["Forquilha II"],
    last_accessed_at: "2026-03-30T19:16:24.197Z",
  },
  {
    project_code: "GIST-VAL-FAB-002",
    standard_acronym: "GISTM",
    site_name: "Fábrica",
    assets: ["Forquilha II", "Forquilha III"],
    last_accessed_at: "2026-03-25T11:07:03.078Z",
  },
  {
    project_code: "GIST-VAL-FAB-003",
    standard_acronym: "GISTM",
    site_name: "Fábrica",
    assets: ["Forquilha II", "Forquilha III", "Forquilha IV"],
    last_accessed_at: "2026-03-20T19:16:24.197Z",
  },
  {
    project_code: "GIST-VAL-FAB-004",
    standard_acronym: "GISTM",
    site_name: "Fábrica",
    assets: ["Forquilha II", "Forquilha III", "Forquilha IV", "Forquilha V"],
    last_accessed_at: "2026-03-18T05:42:02.321Z",
  },
  {
    project_code: "GIST-VAL-FAB-005",
    standard_acronym: "GISTM",
    site_name: "Fábrica",
    assets: ["Forquilha I", "Forquilha II", "Forquilha III", "Forquilha IV", "Forquilha V"],
    last_accessed_at: "2026-03-12T14:16:24.197Z",
  },
];

export const projectStatusMock: ProjectStatusOutput = {
  total: 100,
  items: [
    { status: "assessment", count: 4, percentage: 4 },
    { status: "report", count: 10, percentage: 10 },
    { status: "signatures", count: 26, percentage: 26 },
    { status: "on_hold", count: 10, percentage: 10 },
    { status: "completed", count: 25, percentage: 25 },
    { status: "canceled", count: 25, percentage: 25 },
  ],
};

export const deadlineProjectMock: DeadlineOutput = {
  on_track: 9,
  near_deadline: 3,
  overdue: 5,
  completed: 3,
  total: 20,
  on_track_pct: 45,
  near_deadline_pct: 15,
  overdue_pct: 25,
  completed_pct: 15,
};

export const projectItemsMock: ProjectItem[] = [
  {
    organization_id: 1,
    project_code: "GIST-VAL-FAB-001",
    project_name: "GISTM Vale Fábrica 001",
    project_status: "assessment",
    is_favorite: true,
    deadline_status: "near_deadline",
    signatures_date: "2026-06-30",
    site_name: "Fábrica",
    assets: ["Forquilha II"],
    standard_acronym: "GISTM",
    client_name: "Vale",
  },
  {
    organization_id: 1,
    project_code: "GIST-VAL-FAB-002",
    project_name: "GISTM Vale Fábrica 002",
    project_status: "report",
    is_favorite: false,
    deadline_status: "on_track",
    signatures_date: "2026-09-15",
    site_name: "Fábrica",
    assets: ["Forquilha II", "Forquilha III"],
    standard_acronym: "GISTM",
    client_name: "Vale",
  },
  {
    organization_id: 2,
    project_code: "GIST-BHP-MNG-001",
    project_name: "GISTM BHP Mina Norte 001",
    project_status: "signatures",
    is_favorite: true,
    deadline_status: "overdue",
    signatures_date: "2026-03-01",
    site_name: "Mina Norte",
    assets: ["Mina Norte"],
    standard_acronym: "GISTM",
    client_name: "BHP",
  },
  {
    organization_id: 3,
    project_code: "GIST-ANT-CER-003",
    project_name: "MAC Anglo American Cerro Azul 003",
    project_status: "on_hold",
    is_favorite: false,
    deadline_status: "on_track",
    signatures_date: "2026-12-31",
    site_name: "Cerro Azul",
    assets: ["Cerro Azul"],
    standard_acronym: "MAC",
    client_name: "Anglo American",
  },
  {
    organization_id: 4,
    project_code: "GIST-SAM-ITB-002",
    project_name: "ICOLD Samarco Itabirito 002",
    project_status: "completed",
    is_favorite: true,
    deadline_status: "on_track",
    signatures_date: "2025-12-01",
    site_name: "Itabirito",
    assets: ["Itabirito"],
    standard_acronym: "ICOLD",
    client_name: "Samarco",
  },
  {
    organization_id: 1,
    project_code: "GIST-VAL-CON-001",
    project_name: "GISTM Vale Conceição 001",
    project_status: "canceled",
    is_favorite: false,
    deadline_status: "overdue",
    signatures_date: "2025-06-01",
    site_name: "Conceição",
    assets: ["Conceição", "Itabiruçu"],
    standard_acronym: "GISTM",
    client_name: "Vale",
  },
];

function matchesProjectSearch(
  item: ProjectItem,
  search: string,
  matchMode: SearchMatchMode = DEFAULT_SEARCH_MATCH_MODE
) {
  const normalizedSearch = search.trim().toLowerCase();
  if (!normalizedSearch) return true;

  return [
    item.project_code,
    item.project_name,
    item.site_name,
    item.client_name,
    item.standard_acronym,
    ...item.assets,
  ].some((value) =>
    matchMode === "contains"
      ? value.toLowerCase().includes(normalizedSearch)
      : value.toLowerCase().startsWith(normalizedSearch)
  );
}

function sortProjectItems(items: ProjectItem[], sort: ProjectListParams["sort"]) {
  const sorted = [...items].sort((left, right) => {
    const leftDate = left.signatures_date ?? "";
    const rightDate = right.signatures_date ?? "";

    if (leftDate !== rightDate) {
      return leftDate.localeCompare(rightDate);
    }

    return left.project_code.localeCompare(right.project_code);
  });

  return sort === "desc" ? sorted.reverse() : sorted;
}

function matchesDeadlineFilter(item: ProjectItem, params: ProjectListParams) {
  if (!params.deadline_status?.length) return true;

  const isCompleted = item.project_status === "completed";

  return params.deadline_status.some((status) =>
    status === "completed" ? isCompleted : !isCompleted && item.deadline_status === status
  );
}

export function getMockProjectList(params: ProjectListParams): PaginatedProjectListOutput {
  const page = params.page ?? 1;
  const pageSize = params.page_size ?? 10;

  let filteredItems = projectItemsMock.filter((item) => {
    if (params.search && !matchesProjectSearch(item, params.search, params.match_mode))
      return false;
    if (params.project_code && item.project_code !== params.project_code) return false;
    if (params.project_status?.length && !params.project_status.includes(item.project_status))
      return false;
    if (params.is_favorite !== undefined && item.is_favorite !== params.is_favorite) return false;
    if (!matchesDeadlineFilter(item, params)) return false;
    if (params.site_name && item.site_name !== params.site_name) return false;
    if (params.standard_acronym && item.standard_acronym !== params.standard_acronym) return false;
    if (params.client_name && item.client_name !== params.client_name) return false;
    if (
      params.asset_names?.length &&
      !params.asset_names.some((asset) => item.assets.includes(asset))
    ) {
      return false;
    }

    return true;
  });

  filteredItems = sortProjectItems(filteredItems, params.sort);

  const total = filteredItems.length;
  const start = (page - 1) * pageSize;
  const items = filteredItems.slice(start, start + pageSize);

  return { total, page, page_size: pageSize, items };
}
